module.exports = __webpack_public_path__ + "img/sigfigs_example_2.0e08d11b.png";